import * as core from '../../../../../../../core'
import * as changeImpactSprint from '../change-impact-sprint'

export const RESOURCE = {
  payload: {
    description: 'Sprint 7',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactSprint.RESOURCE.payload.partialId,
    }),
    id: 'Sprint 7',
    name: 'Sprint 7',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
